import { ReportTypes } from '../../../NonReact/constants/ReportTypes'

/**
 * Menu item object type.
 */
export type ReportListItemType = {
    id: string
    name: string
    duration?: number
    rptType?: ReportTypes
    groupingViewType?: number
    supportsIconViews?: boolean
    supportsCharting?: boolean
    supportsRowHighlighting?: boolean
    viewType?: number
    WBTileType?: number
    filterDevices?: string
    filterDevicesMax?: number
    userLicensedFor?: number
    isLicensed?: boolean
    isLicensedRealTime?: boolean
    isScheduleActive?: boolean
    isAutoSwitched?: boolean
    autoSwitchIntervalDisplay?: number
    parentFolderID?: string
    subItems?: ReportListItemType[]
    isReport: boolean
    description: string
    isBinned: boolean
    daysUntilDeletion: number
}

export enum DashboardLayoutStyle {
    HorizontalSplit,
    Layout1Left2Middle2Right,
    Layout1Left2Right,
    Layout1Top2Bottom,
    Layout1Top3Bottom,
    Layout1x1,
    Layout2Top3Bottom,
    Layout2x2,
    Layout3x1,
    Layout3x2,
    VerticalSplit
}

export const DashboardLayoutReportQuantities: number[] = [2, 5, 3, 3, 4, 1, 5, 4, 3, 6, 2]
